/*  imported from AnnouncementColors.module.scss  */

@import '~@tdcerhverv/parrotfish/dist/colors-design-token.scss';

.AnnouncementColors-module__announcement__info___NegJf {
  background-color: map-get($theme, 'info-light');
  color: map-get($theme, 'info-dark');
}

.AnnouncementColors-module__announcement__positive___3hEC8 {
  background-color: map-get($theme, 'success-light');
  color: map-get($theme, 'success-dark');
}

.AnnouncementColors-module__announcement__negative___3TYWe {
  background-color: map-get($theme, 'error-light');
  color: map-get($theme, 'error-dark');
}

.AnnouncementColors-module__announcement__warning___8JMT5 {
  background-color: map-get($theme, 'warning-light');
  color: map-get($theme, 'warning-dark');
}
